export default (res, provider) => {
	switch (provider) {
		case "EMAIL":
			return {
				email: res.email,
				first_name: res.value.result.cognitoUser.attributes.given_name,
				last_name: res.value.result.cognitoUser.attributes.family_name,
				provider: "EMAIL",
				research_field:
					res.value.result.cognitoUser.attributes["custom:research_field"],
				ip_city: res.data.data.city,
				ip_continent: res.data.data.continent,
				ip_country: res.data.data.country,
				ip_country_code: res.data.data.countryCode,
				ip_query: res.data.data.query,
				accepted_news:
					res.value.result.cognitoUser.attributes["custom:accepted_news"]
			}
		case "GOOGLE":
			return {
				email: res.email,
				first_name: res.given_name,
				last_name: res.family_name,
				profile_picture: res.image,
				provider: "GOOGLE",
				accepted_news: true
			}
		case "FACEBOOK":
			return {
				email: res.email,
				first_name: res.first_name,
				last_name: res.last_name,
				profile_picture: res.picture.data.url,
				provider: "FACEBOOK",
				accepted_news: true
			}
		case "LINKEDIN":
			return {
				email: res.email,
				first_name: res.given_name,
				last_name: res.family_name,
				profile_picture: res.picture,
				provider: "LINKEDIN",
				accepted_news: true
			}
		default:
			break
	}
}
